import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getDrivers } from '../api/services/Drivers';
import { DriverSearchResult } from '../types/driver';

export const useDriverSearchQuery = (query) => {
  const cacheKey = ['driverQuery', query];

  return useApiGet<{ data: DriverSearchResult[] }>(cacheKey, () => getDrivers({ q: query, state: 'Certified' }), {
    enabled: true,
  });
};
